import { truckService } from '_services';
import { session } from '_helpers';
import { ACTIONS_TRUCK } from '_constants/truck.constants';
import alertActions from './alert.actions';

export const receiveTrucks = (trucks) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < trucks.length; i++) {
    byIdObjectToDispatch[trucks[i].truckID] = trucks[i];
  }

  return {
    type: ACTIONS_TRUCK.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteTruck = (truckId) => ({
  type: ACTIONS_TRUCK.DELETE,
  byId: { [truckId]: null }
});

const getTrucks = (accountID) => async (dispatch) => {
  try {
    const resp = await truckService.getAll(accountID);
    if (resp?.[0]?.truckID) {
      dispatch(receiveTrucks(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving trucks.', e));
  }
  return null;
};

const getTruck = (truckID) => async (dispatch) => {
  try {
    const resp = await truckService.getById(truckID);
    if (resp?.truckID) {
      dispatch(receiveTrucks([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving truck #${truckID}.`, e));
  }
  return null;
};

const addTruck = (truck) => async (dispatch) => {
  try {
    const resp = await truckService.create(truck);
    if (resp?.truckID) {
      dispatch(receiveTrucks([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updTruck = (truck) => async (dispatch) => {
  try {
    const resp = await truckService.update(truck);
    if (resp?.truckID) {
      dispatch(receiveTrucks([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delTruck = (truckID) => async (dispatch) => {
  try {
    const resp = await truckService.delete(truckID);
    if (resp?.truckID) {
      dispatch(deleteTruck(resp.truckID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing truck #${truckID}.`, e));
  }
  return null;
};

const truckActions = {
  getTrucks,
  getTruck,
  addTruck,
  updTruck,
  delTruck
};

export default truckActions;
